import api from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function isPushSubscribed() {
  if (!pushSupported()) return false;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch {
    return false;
  }
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Este dispositivo no soporta notificaciones push");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permiso de notificaciones denegado");
  const { data } = await api.get("/push/public-key");
  if (!data.public_key) throw new Error("Push no configurado en el servidor");
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    try {
      sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(data.public_key) });
    } catch (e) {
      const msg = (e && e.message) || "";
      if (/permission/i.test(msg)) throw new Error("Permiso de notificaciones denegado");
      if (/not supported|unsupported/i.test(msg)) throw new Error("Este navegador no soporta notificaciones push");
      throw new Error("No se pudo registrar el dispositivo para notificaciones");
    }
  }
  const json = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
  return true;
}

export async function disablePush() {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await api.post("/push/unsubscribe", { endpoint: sub.endpoint, keys: sub.toJSON().keys }).catch(() => {});
    await sub.unsubscribe();
  }
}

// Auto-repara: si el navegador tiene una suscripción, la re-registra en el servidor.
// Cubre el caso en que el endpoint rotó o el servidor perdió la suscripción (el usuario dejaba de recibir push).
export async function resyncPush() {
  if (!pushSupported()) return false;
  try {
    if (Notification.permission !== "granted") return false;
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return false;
    const json = sub.toJSON();
    await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
    return true;
  } catch {
    return false;
  }
}
